const FormField = ({ className, label, required, children }) => (
  <div className={`d-flex flex-column ${className}`}>
    <div className="d-flex gap-2">
      <p className="form-label fs-sm">{label}</p>{" "}
      {required && <p className="text-danger m-0">*</p>}
    </div>
    {children}
  </div>
);

export default FormField;
